module.exports = __webpack_public_path__ + "img/billed_value.bfc63c16.svg";